<app-error [title]="title | translate" [description]="description | translate" [isFullPage]="true"></app-error>